class GrupoPropiedadFamiliaProductoTraduccion
{
  idGrupoPropFamProdTrad = 0;
  nombreGrupo = null;
  idiomas_idIdioma = 0;
  grupoPropiedadFamiliaProducto_idGrupoPropiedad = 0;
  idioma = null;

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = GrupoPropiedadFamiliaProductoTraduccion;
